

import React, { Component, createRef } from 'react';
import Files from 'react-files';

import './styles/_uploader.scss';

const MIN_FILE_SIZE = 0;
const FILE_SIZE_MULTIPLIER = 10000000000;
const MAX_FILE_SIZE_GB = 10 * FILE_SIZE_MULTIPLIER;












export default class Uploader extends Component {


  constructor(props) {
    super(props);

    this._filePickerRef = createRef();
  }

  onFilesChange = async (files) => {
    const { addFilesToQueue, organisationId, onChange, updateAsset } = this.props;

    if (!files.length) {return;}

    this._filePickerRef.current.removeFiles();

    onChange({ isLoading: true, assetId: null });

    const assetId = await addFilesToQueue({
      file: files[0],
      hidden: true,
      metaData: { product: 'PITCH' }
    }, organisationId);
    await updateAsset({ assetId, input: { isPublic: true } });

    onChange({ isLoading: false, assetId });
  };

  setFilePickerRef = (ref) => {
    if (this._filePickerRef.current || !ref) {
      return;
    }

    const { filePickerRefCallBack } = this.props;

    this._filePickerRef.current = ref;

    filePickerRefCallBack(ref);
  };

  render() {
    const { accepts } = this.props;
    return (
      <Files
        className="library-drop-zone--hidden"
        dropActiveClassName="library-drop-zone--active"
        onChange={this.onFilesChange}
        accepts={accepts}
        multiple={false}
        maxFileSize={MAX_FILE_SIZE_GB}
        minFileSize={MIN_FILE_SIZE}
        ref={this.setFilePickerRef}
        clickable={false} />);


  }
}